/**
 * Bowtie Legend Component
 * Shows color coding legend for the Bowtie diagram
 */
import { Shield, AlertTriangle } from 'lucide-react';

export const BowtieLegend = () => (
  <div className="bg-slate-900/90 p-3 rounded-lg border border-slate-700">
    <h4 className="text-slate-300 text-xs font-semibold mb-2">Legend</h4>
    <div className="space-y-1 text-xs">
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 rounded bg-orange-500" />
        <span className="text-slate-400">Threats</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 rounded bg-amber-500" />
        <span className="text-slate-400">Top Event</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 rounded bg-red-500" />
        <span className="text-slate-400">Consequences</span>
      </div>
      <div className="flex items-center gap-2 mt-2 pt-2 border-t border-slate-700">
        <Shield className="w-3 h-3 text-emerald-400" />
        <span className="text-slate-400">Controls:</span>
      </div>
      <div className="pl-5 space-y-1">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded bg-emerald-500" />
          <span className="text-emerald-400">Effective</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded bg-yellow-500" />
          <span className="text-yellow-400">Partial</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded bg-orange-500" />
          <span className="text-orange-400">Weak</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded bg-red-500" />
          <span className="text-red-400">Non-effective</span>
        </div>
      </div>
      <div className="mt-2 pt-2 border-t border-slate-700">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded bg-blue-500" />
          <span className="text-blue-400">Preventive</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded bg-purple-500" />
          <span className="text-purple-400">Recovery</span>
        </div>
      </div>
    </div>
  </div>
);

export default BowtieLegend;
